import styled from "styled-components";

const RootContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  margin-bottom: 10px;
  font-size: 12px;
`;

const Image = styled.img`
  border-radius: 8px;
  width: 55px;
  height: 55px;
  object-fit: cover;
`;

const modules = {
  RootContainer,
  Image,
};

export default modules;
